import React from 'react';
import { protectedRoute } from '@/modules/core/root/protected/route';
import { createRoute } from '@tanstack/react-router';

export const notificationsRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'notifications',
  component: React.lazy(async () => await import('@/app/routes/Notifications')),
  wrapInSuspense: true,
});
